import { useAppStore } from '../app/store/useAppStore';
import { GCameraBrandLogo } from '../components/brand/GCameraBrandLogo';
import { Icon } from '../components/ui/Icon';
import '../styles/brand-logo.css';

export function HomePage() {
  const navigate = useAppStore((state) => state.navigate);
  return <main className="screen home-screen">
    <div className="home-hud-layer" aria-hidden="true">
      <span className="home-grid"/><span className="home-scan-beam"/><span className="home-calibration"/>
      <span className="hud-node node-a"/><span className="hud-node node-b"/><span className="hud-node node-c"/>
      <span className="hud-coordinate coordinate-a">X 025.033964</span><span className="hud-coordinate coordinate-b">Y 121.564142</span>
    </div>
    <header className="home-top mono"><span>SYS 01 <em>ONLINE</em></span><span>VER 1.0.0<br/>SYNC 98%</span></header>
    <section className="home-hero">
      <div className="orbital" aria-hidden="true"><span/><span/><i/><b/></div>
      <GCameraBrandLogo/>
      <p className="brand-tagline">一個瞬間 · 一次相遇</p>
    </section>
    <nav className="home-actions" aria-label="主要功能">
      <button className="primary-nav" onClick={() => navigate('CAMERA_INIT')}><Icon name="camera"/><span>拍照</span></button>
      <button onClick={() => navigate('PROFILE')}><Icon name="user"/><span>個人介紹</span></button>
      <button onClick={() => navigate('ARCHIVE')}><Icon name="archive"/><span>相簿</span></button>
    </nav>
    <footer className="home-footer mono"><span>GRID 28.4<br/>LAT 25.033964<br/>LON 121.564142</span><span>LINK STABLE<br/>G-CAMERA SYSTEM</span><span className="signal-bars"><i/><i/><i/><i/></span></footer>
  </main>;
}
